import React, { Component } from 'react';
import {formatPrice} from '../helpers/helpers'


import QMainProductView from './QMainProductView'
import QBendedView from './QBendedView'
import QHardwareView from './QHardwareView'
import QMiscellaneousView from './QMiscellaneousView'

class ForDisplayUQuote extends Component {

    
    
    
    
    render() {
             
        return (
                    
                <div>
                    <div id="react-no-print">
                        <table id="ecom-products" className="table table-bordered table-striped ">
                            <thead>
                                <tr>               
                                    <th className="text-center" colSpan="2">Customer Information</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr className="reviewQt">
                                    <td>Quotation Number : <span className="rvwQtData">{this.props.quotation.quoteNumber}</span></td>
                                    <td>Date Of Quotation : <span className="rvwQtData">{this.props.quotation.quoteDate}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Customer Name : <span className="rvwQtData">{this.props.customer.name}</span></td>
                                    <td>contact Number : <span className="rvwQtData">{this.props.customer.number}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Project : <span className="rvwQtData">{this.props.customer.project}</span></td>
                                    <td>Reference : <span className="rvwQtData">{this.props.customer.reference}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Location / Delivery site : <span className="rvwQtData">{this.props.customer.location}</span></td>
                                    <td>Sales Representative : <span className="rvwQtData">{this.props.customer.representative}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="forMobileWrap">
                            <div className="wrapperTable">
                                <table className="table table-bordered table-striped ">
                                    <thead>
                                        <tr>
                                            <th className="text-left forRoofType">Product Name</th>
                                            <th className="text-left forDimension">Dimension</th>
                                            <th className="text-left forThickness">Thickness</th>
                                            <th className="text-center forLengthSize">Quantity</th>
                                            <th className="text-center forUnitType">Unit</th>
                                            <th className="text-center forPriceValue">Price</th>
                                            <th className="text-center forUnitDesc">Per Unit</th>
                                            <th className="text-center forUnitDesc">Discount</th>
                                            <th className="text-center forAreaValue">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.props.products &&                                     
                                                    Object.keys(this.props.products).map(function (key){
                                                        let list = this.props.products[key]
                                                        
                                                        if(list.category ==="Main Product"){                                                   
                                                            //console.log(list)
                                                            return <QMainProductView key={key} product={list}/>                                                  
                                                           }

                                                        if(list.category ==="Bended Accessories"){                                                   
                                                            //console.log(list)
                                                            return <QBendedView key={key} product={list}/>                                                  
                                                           }
                                                                                                
                                                           
                                                    }.bind(this))

                                        }
                                        
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Subtotal</td>
                                            <td></td>
                                            <td>{formatPrice(this.props.quotation.totalValue) && formatPrice(this.props.quotation.totalValue)}</td>
                                        </tr>
                                        {
                                            this.props.products &&                                     
                                                    Object.keys(this.props.products).map(function (key){
                                                        let list = this.props.products[key]
                                                        
                                                        if(list.category ==="Hardware Accessories"){                                                   
                                                            //console.log(list)
                                                            return <QHardwareView key={key} product={list}/>                                                  
                                                           }

                                                        if(list.category ==="Miscellaneous"){                                                   
                                                            //console.log(list)
                                                            return <QMiscellaneousView key={key} product={list}/>                                                  
                                                           }
                                                                                                
                                                           
                                                    }.bind(this))

                                        }
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Miscellaneous</td>
                                            <td>and</td>
                                            <td> Hardware</td>
                                            <td>Subtotal</td>
                                            <td></td>
                                            <td>{formatPrice(this.props.quotation.totalValue2) && formatPrice(this.props.quotation.totalValue2)}</td>
                                        </tr>
                                        <tr>
                                            <td>TERMS OF PAYMENT </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>*50% down payment upon placement of order</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Total Materials</td>
                                            <td></td>
                                            <td>{formatPrice(this.props.quotation.totalMaterials) && formatPrice(this.props.quotation.totalMaterials)}</td>
                                        </tr>
                                        <tr>
                                            <td>*50% full payment upon notice of delivery</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Delivery Cost</td>
                                            <td></td>
                                            <td>{formatPrice(this.props.quotation.deliveryCharge) && formatPrice(this.props.quotation.deliveryCharge)}</td>
                                        </tr>
                                        <tr className="grandTotalTdRow">                                        
                                            <td>DELIVERY SCHEDULE:</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="grandTotalQ" colSpan={2}>Total Quotation</td>
                                            
                                            <td className="grandTotal">{formatPrice(this.props.quotation.totalQuote) && formatPrice(this.props.quotation.totalQuote)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-uppercase">{this.props.customer.sched}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td className="text-uppercase">{this.props.customer.eta}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
                    
                
      
        );
    }
}

export default ForDisplayUQuote;



// WEBPACK FOOTER //
// ./src/components/ForDisplayUQuote.js